import logo from "../../images/Manager_trasp_bianco.png";

const ThankYou = () => {
  const htmlContent = `
    <!doctype html>
    <html>
    <head>
      <meta charset="utf-8">
      <meta name="viewport" content="width=device-width, initial-scale=1">
      <title>SportId Manager - Grazie</title>
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap" rel="stylesheet">
      <style type="text/css">
        body {
          background-image: url(https://sportid.it/wp-content/uploads/2025/05/manager.jpg);
          background-size: cover;
          background-position: center center;
          margin: 0;
          padding: 0;
          color: #FFF;
          font-family: Arial, sans-serif;
          font-size: 1em;
          line-height: 155%;
        }
        #content {
          display: flex; 
          flex-direction: column;
          height: 100vh;
          width:100%; 
          text-align: center;
          justify-content:space-between; 
          background: rgba(0,0,0,0.75)
        }
        .bebas-neue-regular {
          font-family: "Bebas Neue", sans-serif;
          font-weight: 400;
          font-style: normal;
        }
        a.button {
          background: #F39200;
          padding:12px 36px;
          font-family: "Bebas Neue", sans-serif;
          color:#FFF;
          font-size: 1.2em;
          text-decoration: none;
        }
        a.button:hover {
          background: #000;
          color: #F39200;
        }
        .conText {
          width: 80%;
          margin: auto;
        }
        .conText h4 {
          margin-bottom: 56px;
        }
      </style>
    </head>

    <body>
      <div id="content">
        <img src="${logo}" style="width:210px; margin: 24px auto 0">
        <div>
          <h2 style="text-align: center; color:#FFF; font-size: 2.5em; line-height: 120%" class="bebas-neue-regular">Grazie per aver scelto SportId Manager<sup>®</sup></h2>
          <div>
            <div class="conText">
              <p>Entra nella tua email e clicca sul link per verificare la tua registrazione. <br>
              <strong>SportId Manager® </strong>ti aiuterà a digitalizzare la tua struttura sportiva e ti farà <strong>risparmiare tempo e guadagnare soldi</strong>.</p>
              <p>Come faccio a guadagnare? Con il <strong>programma Donaction</strong>.</p>
              <p>1. Importa i tuoi contatti nel sistema.</p>
              <p>2. Sportid Manager® invierà una comunicazione per far scaricare a tutti i tuoi contatti SportId® Player.</p>
              <p>3. Se un tuo contatto acquisterà l'abbonamento SportId® Player Premium utilizzando il tuo DonAction Code (lo trovi nella sezione IDS di SportId Manager®) guadagnerai €10.</p>
              <!-- <p style="margin-top: 30px;"><a class="button" href="https://manager.sportid.it/login">Verifica e-mail</a></p> -->
            </div>
          </div>
        </div>
        <div>&nbsp;</div>
      </div>
    </body>
    </html>
  `;

  return <div dangerouslySetInnerHTML={{ __html: htmlContent }} />;
};

export default ThankYou;
